import React, { useRef, useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import Book3DModel from "./libs/Book3DModel";
import {Icon} from "@iconify/react";
import askClaude from "./libs/claude";
import BackgroundImages from "./libs/BackgroundImage";
import BackgroundGif from "./libs/backgroundGif";

export default function App() {
    const [step, setStep] = useState(1);
    const [name, setName] = useState('');
    const [claudeResponse, setClaudeResponse] = useState({ar: '', desc: ''});

    const STEP_3_DURATION = 8000; // 8 secondes
    const STEP_4_DURATION = 4000; // 4 secondes

    useEffect(() => {
        let timer: any;
        if (step === 3 && claudeResponse.ar && claudeResponse.desc) {
            timer = setTimeout(() => {
                setStep(4);
            }, STEP_3_DURATION);
        } else if (step === 4) {
            timer = setTimeout(() => {
                setStep(5);
            }, STEP_4_DURATION);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [step, claudeResponse]);

    const handleContinue = () => {
        setStep(2);
    }

    const handleSubmit = () => {
        setStep(3);

        askClaude(name)
            .then(response => {
                if (response) {
                    setClaudeResponse(response)
                    console.log('Réponse de Claude:', response);
                }
            });
    }

    // Fonction pour rendre le background approprié selon l'étape
    const renderBackground = () => {
        if (step === 3) {
            return <BackgroundImages />;
        } else if (step === 4 || step === 5) {
            return <BackgroundGif />;
        }
        return null;
    };

    return (
        <div className="overflow-hidden overscroll-y-none h-full w-full relative">
            <div
                className="animate-custom-pulse bg-blue-950 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full z-0 blur-3xl opacity-5"
            ></div>

            {/* Background conditionnel */}
            {renderBackground()}

            {step === 1 && (
                <div className="absolute w-full h-full z-20 flex flex-col items-center pt-16 gap-16">
                    <h1 className="text-white font-homoneta text-6xl text-center fade-in">Découvre <br/> ton arôme</h1>
                    <button
                        className="font-homoneta text-gray-950 text-2xl font-bold bg-[#b0a583] px-10 pt-2 pb-3 rounded-full fade-in delay-300"
                        onClick={handleContinue}
                    >
                        Continuer
                    </button>
                </div>
            )}

            {step === 2 && (
                <div className="z-20 absolute w-full h-full flex flex-col items-center justify-end gap-32 pb-10">
                    <div className="flex flex-col items-center justify-center gap-10">
                        <h1 className="text-white font-homoneta text-6xl text-center fade-in">Quel est ton <br/> joli
                            nom ?</h1>
                        <div className="flex flex-row items-center justify-center gap-4 h-[50px]">
                            <input
                                type="text"
                                className="px-5 py-2 rounded-full bg-gray-100 font-semibold h-full fade-in delay-300"
                                value={name}
                                placeholder="Nom"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div>
                        {name && (
                            <button
                                className="font-homoneta font-bold bg-[#b0a583] px-3 py-3 rounded-full fade-in delay-500"
                                onClick={handleSubmit}
                            >
                                <Icon className="text-white" icon="material-symbols:arrow-forward-rounded" width={40}/>
                            </button>
                        )}
                    </div>
                </div>
            )}

            {step === 4 && (
                <div className="absolute w-full h-full z-20 flex flex-col items-center pt-32 gap-10 px-5">
                    <h1 className="text-white font-homoneta text-6xl text-center fade-in">{name}</h1>
                    <h1 className="text-white font-homoneta text-3xl text-center fade-in delay-300">Ton nom nous inspire
                        un arôme tout particulier.</h1>
                </div>
            )}

            {step === 5 && (
                <div className="absolute w-full h-full px-5 z-20 flex flex-col items-center pt-16 gap-16">
                    <h1 className="text-white font-homoneta text-3xl text-center fade-in delay-300">{claudeResponse.ar}</h1>
                    <h1 className="text-white font-homoneta text-xl text-center fade-in delay-500">{claudeResponse.desc}</h1>
                </div>
            )}

            <div className="relative h-screen w-screen z-10">
                <div className="absolute w-full h-full">
                    <Canvas camera={{position: [0, 0, 100], fov: 30}}>
                        <ambientLight intensity={0.3}/>
                        <directionalLight position={[10, 10, 10]} intensity={1}/>
                        <directionalLight position={[-10, 5, 10]} intensity={1} color={0x6789f3}/>
                        <directionalLight position={[0, 10, -10]} intensity={1}/>

                        <Book3DModel
                            preset={step}
                            transitionDuration={3000}
                        />
                    </Canvas>
                </div>
            </div>
        </div>
    );
}